<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="partnerTypeForm" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="合伙人类型:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入合伙人类型..." size="small" />
        </FormItem>
        <FormItem label="合伙人代号:" prop="code">
          <Input v-model="formFields.code" placeholder="请输入合伙人代号..." size="small" />
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'RoleFormDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      formFields: {
        name: '',
        id: this.id,
        code: ''
      }
    }
  },
  computed: {
    ruleValidate() {
      return {
        name: [{ required: true, message: '合伙人类型不能为空!', trigger: 'blur' }],
        code: [{ required: true, message: '合伙人代号不能为空!', trigger: 'blur' }]
      }
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑合伙人类型' : '添加新合伙人类型'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          this.formFields = res.data
        }).catch(() => {
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.partnerTypeForm.resetFields()
      this.formFields.id = 0
    },
    saveOrUpdate: function() {
      this.$refs.partnerTypeForm.validate((valid) => {
        if (valid) {
          this.submit = true
          const isNew = this.formFields.id === 0
          request({
            url: this.action + (isNew ? '' : ('/' + this.id)),
            method: isNew ? 'POST' : 'PUT',
            data: this.formFields
          }).then(res => {
            this.loadingStatus = false
            this.formFields = res.data
            this.$Notice.success({
              title: '合伙人类型 `' + this.formFields.name + '` 保存成功!'
            })
            this.submit = false
            this.closeModal(true)
          }).catch(() => {
            this.loadingStatus = false
            this.submit = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

